import { render, staticRenderFns } from "./MeasurePoint.vue?vue&type=template&id=39d6f922&scoped=true"
import script from "./MeasurePoint.vue?vue&type=script&lang=js"
export * from "./MeasurePoint.vue?vue&type=script&lang=js"
import style0 from "./MeasurePoint.vue?vue&type=style&index=0&id=39d6f922&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "39d6f922",
  null
  
)

export default component.exports